import { Component, OnInit } from '@angular/core';
import { BankStatementsService } from '../../../services/bank-statements.service';
import { BankStatement, BankStatementCreate, BankStatementUpdate } from '../../../models/BankStatement';

@Component({
  selector: 'app-bank-statements',
  templateUrl: './bank-statements.component.html',
  styleUrls: ['./bank-statements.component.css']
})
export class BankStatementsComponent implements OnInit {
  tableTitle = 'Extratos Bancários';
  showSearch = true;
  searchPlaceholder = 'Pesquisar extratos...';
  clickable = true;

  columns = [
    { titulo: 'Banco', label: 'bankName' },
    { titulo: 'Data', label: 'statementDate', pipe: 'date' },
    { titulo: 'Saldo Inicial', label: 'openingBalance', pipe: 'currency' },
    { titulo: 'Saldo Final', label: 'closingBalance', pipe: 'currency' }
  ];

  actions = [
    { label: 'Visualizar', icon: 'fas fa-eye', action: 'view', class: 'btn-view' },
    { label: 'Editar', icon: 'fas fa-pen-to-square', action: 'edit', class: 'btn-edit' },
    { label: 'Excluir', icon: 'fas fa-trash-can', action: 'delete', class: 'btn-delete' }
  ];

  statements: BankStatement[] = [];
  loading = false;
  error: string | null = null;

  selectedBank: string = '';
  startDate: string = '';
  endDate: string = '';

  constructor(private bankStatementsService: BankStatementsService) {}

  ngOnInit(): void {
    this.applyFilters();
  }

  onSearch(term: string): void {
    this.applyFilters();
  }

  onBankChange(value: string): void {
    this.selectedBank = value;
    this.applyFilters();
  }

  onDateRangeChange(): void {
    this.applyFilters();
  }

  applyFilters(): void {
    this.loading = true;
    this.error = null;

    if (!this.selectedBank || !this.selectedBank.trim()) {
      // Se não tiver banco selecionado, chama GetAll
      this.bankStatementsService.getAll().subscribe({
        next: (res) => {
          this.statements = res || [];
          this.loading = false;
        },
        error: (err) => {
          this.error = err?.message || 'Erro ao carregar extratos';
          this.loading = false;
          this.statements = [];
        }
      });
      return;
    }

    this.bankStatementsService.getByBank(this.selectedBank, this.startDate || undefined, this.endDate || undefined).subscribe({
      next: (res) => {
        this.statements = res.items || [];
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.message || 'Erro ao carregar extratos';
        this.loading = false;
        this.statements = [];
      }
    });
  }

  clearFilters(): void {
    this.selectedBank = '';
    this.startDate = '';
    this.endDate = '';
    this.statements = [];
  }

  onActionClick(actionData: { action: string; item: any }): void {
    const { action } = actionData;
    if (action === 'view') { return; }
    if (action === 'edit') { this.openEdit(actionData.item); return; }
    if (action === 'delete') { this.deleteItem(actionData.item?.id); return; }
  }

  onRowClick(item: any): void {}

  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  showForm: boolean = false;
  editMode: boolean = false;
  currentId: number | null = null;
  formData: { bankName: string; statementDate: string; openingBalance: number; closingBalance: number } = { bankName: '', statementDate: '', openingBalance: 0, closingBalance: 0 };

  openNew(): void {
    this.editMode = false;
    this.currentId = null;
    this.formData = { bankName: '', statementDate: '', openingBalance: 0, closingBalance: 0 };
    this.showForm = true;
  }

  openEdit(item: BankStatement): void {
    this.editMode = true;
    this.currentId = item.id;
    this.formData = {
      bankName: item.bankName ?? '',
      statementDate: item.statementDate ? new Date(item.statementDate).toISOString().substring(0, 10) : '',
      openingBalance: item.openingBalance ?? 0,
      closingBalance: item.closingBalance ?? 0
    };
    this.showForm = true;
  }

  cancelForm(): void {
    this.showForm = false;
  }

  submitForm(): void {
    const payload: any = {
      bankName: this.formData.bankName,
      statementDate: this.formData.statementDate,
      openingBalance: Number(this.formData.openingBalance),
      closingBalance: Number(this.formData.closingBalance)
    };
    this.loading = true;
    this.error = null;
    const done = () => { this.loading = false; this.showForm = false; this.applyFilters(); };
    const fail = (err: any) => { this.error = err?.message || 'Erro ao salvar'; this.loading = false; };
    if (this.editMode && this.currentId) {
      this.bankStatementsService.update(this.currentId, payload).subscribe({ next: done, error: fail });
    } else {
      this.bankStatementsService.create(payload).subscribe({ next: done, error: fail });
    }
  }

  deleteItem(id: number): void {
    if (!id) return;
    this.loading = true;
    this.error = null;
    this.bankStatementsService.delete(id).subscribe({
      next: () => { this.loading = false; this.applyFilters(); },
      error: (err) => { this.error = err?.message || 'Erro ao excluir'; this.loading = false; }
    });
  }
}
